import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useUserContext } from '../context/user/UserProvider'
import { IUserData } from '../queries/user/types'
import { useQueryClient } from '@tanstack/react-query'
import { userKeys } from '../queries/user/keyFactory'
import { buildLoginPathWithRedirect } from '../helpers/authRedirect'

export interface PrivateRouteProps {
  redirectPath?: any
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  redirectPath = '/login',
}) => {
  const queryClient = useQueryClient()
  const user = queryClient.getQueryData(userKeys.user) as IUserData
  const { setInitialUrl } = useUserContext()
  const location = useLocation()
  const pathAndSearchUrl = `${location.pathname}${location.search}${location.hash}`

  useEffect(() => {
    setInitialUrl(pathAndSearchUrl)
  }, [pathAndSearchUrl])

  if (!user && pathAndSearchUrl) {
    return (
      <Navigate
        to={buildLoginPathWithRedirect(redirectPath, pathAndSearchUrl)}
        replace
      />
    )
  }

  return <Outlet />
}

export default PrivateRoute
